// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mg-3";
export var downloadButton = "_mg-4";
export var fileContainer = "_mg-9 _mg-7";
export var fileContainerBase = "_mg-7";
export var fileContainerFixedHeight = "_mg-8 _mg-7";
export var fileInfo = "_mg-5";
export var fileInfoWidthRestricted = "_mg-6";
export var fileType = "_mg-1";
export var fileTypeName = "_mg-2";
export var image = "_mg-0";
export var link = "_mg-b";
export var overflowEllipsis = "_mg-a";